import useAsyncData from "../../../../hooks/use-async-data";
import billingService from "../../billings.service";
import BillingsTaxiTaxiDetails from "./billings-taxi-taxi-details";
import BillingsTaxiTaxiDetailsParams from "./billings-taxi-taxi-details-params";

const useBillingsTaxiTaxiDetails = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsTaxiTaxiDetails | null>(null);

  const load = async (
    params: BillingsTaxiTaxiDetailsParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.getTaxiTaxiBillingsDetails(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsTaxiTaxiDetails;
